import type { ErrorT } from '@app/services/rtkQuery/baseQuery';

export type ASPNetCoreSourceType = {
  status: string;
  data: string;
};

export type ASPNetCoreErrorDataType = {
  type: string;
  title: string;
  status: number;
  errors: Record<string, string[]>;
  traceId: string;
};

export type ErrorResponse = {
  status: 'ERROR' | 'WARNING';
  data: string;
};

export type ErrorPair = { flag: boolean; error: ErrorT };
